import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import cn from "classnames";
import { type ComponentPropsWithoutRef } from "react";
import { useGetVideoThumbnailURL } from "@/components/common/VideoService/hooks";
import { type VideoSource } from "@/constants/media";
import { type UploadedImage } from "@/types";
import s from "./Thumbnail.module.scss";

export interface ThumbnailProps extends ComponentPropsWithoutRef<"button"> {
  source: VideoSource;
  videoId?: string;
  thumbnail?: UploadedImage;
  size?: "small" | "large";
}

export default function Thumbnail(props: ThumbnailProps) {
  const { source, videoId, thumbnail, size = "large", ...buttonProps } = props;

  const thumbnailURL = useGetVideoThumbnailURL(source, videoId, thumbnail);

  const className = cn(s.wrapper, props.className, {
    [s.small]: size === "small",
    [s.large]: size === "large",
  });

  return (
    <button
      {...buttonProps}
      className={className}
      style={{
        ...props.style,
        backgroundImage: thumbnailURL ? `url(${thumbnailURL})` : undefined,
      }}
    >
      <PlayCircleOutlineIcon />
    </button>
  );
}
